export default __webpack_public_path__ + "static/iso_9001-5f0286babb81594a439beeaed7837b47.webp";